import React from "react";
import { Navigate } from "react-router-dom";

import { useCandidateStatus } from "./CandidateStatusContext";

const CandidateRouteGuard = ({ requiredRequest, children }) => {
    const { loading, error, refresh, onboardingCompleted, isApproved } =
        useCandidateStatus();

    if (loading) {
        return (
            <div className="centered-message">
                <div className="spinner"></div>
                <div>Loading...</div>
            </div>
        );
    }

    if (error || onboardingCompleted === null) {
        return (
            <div className="centered-message">
                <div>Could not load your status.</div>
                <button onClick={() => refresh()}>Retry</button>
            </div>
        );
    }

    // Onboarding not finished (or page has no edit type): normal onboarding
    if (!onboardingCompleted || !requiredRequest) {
        return children;
    }

    // Onboarding finished: page opens only through an approved edit request
    if (!isApproved(requiredRequest)) {
        return <Navigate to="/candidate/candidate-dashboard" replace />;
    }

    return React.isValidElement(children)
        ? React.cloneElement(children, { isEditMode: true })
        : children;
};

export default CandidateRouteGuard;